export const lastEventIdStore = new Map<string, string>();
